import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Widget from "./Widget";

export class Dashboard extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true
		}
	}
	componentDidMount() {
		this.refreshData();
	}
	refreshData() {
		this.httpPost("api/v1/dashboard")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	newWidget() {
		this.showComponents({ component: <Widget Caller={this} /> });
	}
	editWidget(id) {
		this.showComponents({
			component: <Widget Caller={this} Id={id} />
		});
	}
	fastAccessWidget(widget) {
		return <div className="dashboard-widget gray" widget-id="1">
			<div className="widget-header">
				<div className="widget-header-div">
					<div className="widget-header-back" style={{ "border-bottom-color": "#5bc0de" }} ></div>
					<div className="widget-header-title">{widget.title}</div>
					<div className="widget-header-buttons">
						<div className="widget-header-button move">
							<span className="fa fa-arrows-alt"></span>
						</div>
						<div className="widget-header-button config" onClick={e => this.editWidget(widget.id)}><span className="fa fa-cogs"></span></div>
					</div>
				</div>
			</div>
			<div className="widget-body">
				<div className="widget-body-back"></div>
				<div className="widget-body-content">
					<div className="ng-isolate-scope">
						<div className="container-fluid">
							<div className="row">
								{widget.options.includes('[add_placeholder]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>سهامداران</a>
								</div>}
								{widget.options.includes('[coding]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>جدول حسابها</a>
								</div>}
								{widget.options.includes('[detail_account]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>حسابهای تفصیلی</a>
								</div>}
								{widget.options.includes('[new_document]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>ثبت سند حسابداری</a>
								</div>}
								{widget.options.includes('[invoice_sale]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>ثبت فاکتور فروش</a>
								</div>}
								{widget.options.includes('[recievment]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>دریافت وجه</a>
								</div>}
								{widget.options.includes('[payment]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>پرداخت وجه</a>
								</div>}
								{widget.options.includes('[mony_transafer]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>انتقال وجه</a>
								</div>}
								{widget.options.includes('[cheque_in]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>چکهای دریافتی</a>
								</div>}
								{widget.options.includes('[cheque_out]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>چکهای پرداختی</a>
								</div>}
								{widget.options.includes('[add_remittance3]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>ثبت رسید انبار</a>
								</div>}
								{widget.options.includes('[add_remittance4]') && <div className="col-md-4 col-sm-12 col-xs-12">
									<a className="btn btn-sm btn-info quick-access-btn hand" style={{ "margin": "5px 0", "width": "100%" }}>ثبت حواله انبار</a>
								</div>}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	renderOld() {
		return <div>			<div className="row">
			<div className="app-dashboard-column col-sm-6" column-index="1">
				{this.state.data.widgets.map(w => [
					w.widgetType === 1 && this.fastAccessWidget(w)
				])}
			</div>
			<div className="app-dashboard-column col-sm-6" column-index="2">

			</div>
		</div>
			<div className="row">
				<div className="col-sm-12 text-center">
					<button onClick={e => this.newWidget()} className="btn btn-success app-dashboard-new"><span className="fa fa-plus m-l-5"></span> ابزار جدید</button>
				</div>
			</div></div>
	}
	renderForm() {
		return <div className="container app-dashboard-background">
			<div className="row">
				<div className="col-sm-6">
					<div className="dashboard-widget gray">
						<div className="widget-header">
							<div className="widget-header-div">
								<div className="widget-header-back" style={{ "border-bottom-color": "#5bc0de" }} ></div>
								<div className="widget-header-title">چکهای دریافتنی و پرداختی</div>
							</div>
						</div>
						<div className="widget-body">
							<div style={{ "gap": "5px","padding": "5px","display": "flex", "flex-direction":"column","overflow": "hidden"}}>
								<div className="row bg-info pd-5">
									<div className="col-sm-6">تعداد چک دریافتنی</div>
									<div className="col-sm-6 text-left"><strong>{this.money(this.state.data.chequesInCount)}</strong></div>
								</div>
								<div className="row bg-danger pd-5">
									<div className="col-sm-6">تعداد چک پرداختی</div>
									<div className="col-sm-6 text-left"><strong>{this.money(this.state.data.chequesOutCount)}</strong></div>
								</div>
								<div className="row bg-info pd-5">
									<div className="col-sm-6">مجموع چکهای دریافتنی</div>
									<div className="col-sm-6 text-left"><strong>{this.money(this.state.data.chequesInSum)}</strong></div>
								</div>
								<div className="row bg-danger pd-5">
									<div className="col-sm-6">مجموع چکهای پرداختی</div>
									<div className="col-sm-6 text-left"><strong>{this.money(this.state.data.chequesOutSum)}</strong></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-6">
					<div className="dashboard-widget gray">
						<div className="widget-header">
							<div className="widget-header-div">
								<div className="widget-header-back" style={{ "border-bottom-color": "#5bc0de" }} ></div>
								<div className="widget-header-title">موجودی صندوقها</div>
							</div>
						</div>
						<div className="widget-body">
							<div style={{ "gap": "5px", "padding": "5px", "display": "flex", "flex-direction": "column", "overflow": "hidden" }}>
								{this.state.data.cashDesks.map(item => <div className="row pd-5">
									<div className="col-sm-6">{item.name}</div>
									<div className={"col-sm-6 text-left" + (item.bes > item.bed ? " text-red" : "")}><strong>{this.money(item.bed - item.bes)}</strong> ({this.state.data.global.company.currencyUnit})</div>
								</div>)}
								<div className="row bg-primary pd-5">
									<div className="col-sm-6">جمع کل</div>
									<div className={"col-sm-6 text-left" + (this.state.data.cashDesksSumbes > this.state.data.cashDesksSumbed ? " text-red" : "")}><strong>{this.money(this.state.data.cashDesksSumbed - this.state.data.cashDesksSumbes)}</strong> ({this.state.data.global.company.currencyUnit})</div>
								</div>
							</div>
						</div>
					</div>
					<div className="dashboard-widget gray">
						<div className="widget-header">
							<div className="widget-header-div">
								<div className="widget-header-back" style={{ "border-bottom-color": "#5bc0de" }} ></div>
								<div className="widget-header-title">موجودی بانکها</div>
							</div>
						</div>
						<div className="widget-body">
							<div style={{ "gap": "5px", "padding": "5px", "display": "flex", "flex-direction": "column", "overflow": "hidden" }}>
								{this.state.data.bankAccounts.map(item => <div className="row pd-5">
									<div className="col-sm-6">{item.name}</div>
									<div className={"col-sm-6 text-left" + (item.bes > item.bed ? " text-red" : "")}><strong>{this.money(item.bed - item.bes)}</strong> ({this.state.data.global.company.currencyUnit})</div>
								</div>)}
								<div className="row bg-primary pd-5">
									<div className="col-sm-6">جمع کل</div>
									<div className={"col-sm-6 text-left" + (this.state.data.bankAccountsSumbes > this.state.data.bankAccountsSumbed ? " text-red" : "")}><strong>{this.money(this.state.data.bankAccountsSumbed - this.state.data.bankAccountsSumbes)}</strong> ({this.state.data.global.company.currencyUnit})</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent(),
			];

		return contents;
	}
}